module.exports = __webpack_public_path__ + "static/media/edit-thin.d26261db.svg";